import Service from "lib/models/Service";

export default class AdService extends Service {
  fetchAdCampaign(adType: AdType, page = 1, size = 3) {
    return this.get("/ad-campaign", { adType, page, size });
  }

  saveAdCampaign(adType: AdType, lawyers: number[]) {
    return this.post("/ad-campaign", { adType, lawyers });
  }

  fetchLawyers(): Promise<{ results: ResLawyer[] }> {
    return this.get(`/lawyers`, { size: 100 });
  }
}
